/** CoStar.Api.ListingMarketplace.ListingAnalytics.ViewModels.Models.ListingAnalyticsTimeFrame */
export var ListingAnalyticsTimeFrame;
(function (ListingAnalyticsTimeFrame) {
    ListingAnalyticsTimeFrame[ListingAnalyticsTimeFrame["Days30"] = 1] = "Days30";
    ListingAnalyticsTimeFrame[ListingAnalyticsTimeFrame["Days90"] = 2] = "Days90";
    ListingAnalyticsTimeFrame[ListingAnalyticsTimeFrame["Days180"] = 4] = "Days180";
})(ListingAnalyticsTimeFrame || (ListingAnalyticsTimeFrame = {}));
/** CoStar.Api.ListingMarketplace.ListingAnalytics.ViewModels.Models.ListingAnalyticsType */
export var ListingAnalyticsType;
(function (ListingAnalyticsType) {
    ListingAnalyticsType[ListingAnalyticsType["ProfileViews"] = 0] = "ProfileViews";
    ListingAnalyticsType[ListingAnalyticsType["ReturnedInSearch"] = 1] = "ReturnedInSearch";
    ListingAnalyticsType[ListingAnalyticsType["EmailAlerts"] = 2] = "EmailAlerts";
    ListingAnalyticsType[ListingAnalyticsType["ProspectListEmailSent"] = 3] = "ProspectListEmailSent";
    ListingAnalyticsType[ListingAnalyticsType["ListingEmailSent"] = 4] = "ListingEmailSent";
    ListingAnalyticsType[ListingAnalyticsType["EmailLeads"] = 5] = "EmailLeads";
})(ListingAnalyticsType || (ListingAnalyticsType = {}));
